define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseCollection = require("collections/BaseCollection");
    var IntegrationsEnum = require("manager-assets/data/data-sources/integrations/IntegrationsEnum.json");
    var IntegrationsCategoryModel = require("manager-models/data-sources/integrations/IntegrationsCategoryModel");

    var CONST = {
        CONNECTION_INIT_VALUE: -1,
        NO_CONNECTION_VALUE: 0
    };


    var IntegrationsCategoriesCollection = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        IntegrationsCategoriesCollection = BaseCollection.extend({
            model : IntegrationsCategoryModel,

            getAuthenticationServerRow: function () {
                var connectorsCategoryModel = this.get(IntegrationsEnum.CATEGORIES.CONNECTORS);
                var connectorsCategoryRows = connectorsCategoryModel.getRowsCollection();
                return connectorsCategoryRows.get(IntegrationsEnum.ROWS.AUTHENTICATION_SERVER);
            },

            getAutomotiveRow: function () {
                var engagementAttributesCategoryModel = this.get(IntegrationsEnum.CATEGORIES.ENGAGEMENT_ATTRIBUTES);
                var engagementAttributesCategoryRows = engagementAttributesCategoryModel.getRowsCollection();
                return engagementAttributesCategoryRows.get(IntegrationsEnum.ROWS.AUTOMOTIVE);
            },


            updateConnectionsFromConnectors: function(conns, ConnectorsConfig){
                //the configData is usually url coming back from the Google API
                var rowsCollection = this.getConnectorsRowsCollection();
                _.each(conns, function(conn, index){
                    var id = parseInt(conn.id, 10);
                    var model = rowsCollection.get(id);

                    //update the connection status
                    model.setConnections(conn.isConnected ? 1 : 0);
                    model.setConnectorConfig(ConnectorsConfig);

                    if (model.isGoogleAnalytics()){
                        LE.context.set("googleAnalyticsConnectionStatus", conn.isConnected);
                    }
                }, this);
            },
            getAttributesRowsCollection: function(){
                var attributesCategoryModel = this.get(IntegrationsEnum.CATEGORIES.ENGAGEMENT_ATTRIBUTES);
                var attributesCategoryRows = attributesCategoryModel.getRowsCollection();
                return attributesCategoryRows;
            },
            getConnectorsRowsCollection: function(){
                var connectorsCategoryModel = this.get(IntegrationsEnum.CATEGORIES.CONNECTORS);
                var connectorsCategoryRows = connectorsCategoryModel.getRowsCollection();
                return connectorsCategoryRows;
            },
            getAllMetricsParameterNames: function(){
                var attributeParams = this._getAttributesMetricParamNames();
                var connectorParams = this._getConnectorsMetricParamNames();
                var result = attributeParams.concat(connectorParams);
                return result;
            },
            updateConnectionsFromMetrics: function(dataSourceCountModel){
               this._updateAttributesConnections(dataSourceCountModel);
               this._updateMetricsConnectorsConnections(dataSourceCountModel);
            },
            _getAttributesMetricParamNames: function(){
                var result = [];
                var rowsCollection = this.getAttributesRowsCollection();
                _.each(rowsCollection.models, function(row){
                    result.push(row.getAttributesMetricsNames());
                });
                return result;
            },
            _getConnectorsMetricParamNames: function(){
                var result = [];
                var rowsCollection = this.getConnectorsRowsCollection();
                _.each(rowsCollection.models, function(row){
                    if (row.isMetricTypeConnection()){
                        result.push(row.getMetricName());
                    }
                });
                return result;
            },
            _updateAttributesConnections: function(dataSourceCountModel){
                var rowsCollection = this.getAttributesRowsCollection();

                if (_.isEmpty(dataSourceCountModel)){
                    _.each(rowsCollection.models, function(model){
                        model.setConnections(CONST.CONNECTION_INIT_VALUE); //unknown
                    });
                    return;
                }
                var leftAttributesCollection, rightAttributesCollection = null;
                var dataMetrics = dataSourceCountModel.get("dataMetrics");
                var that = this;
                _.each(rowsCollection.models, function(row){
                    leftAttributesCollection = row.getLeftAttributesCollection();
                    rightAttributesCollection = row.getRightAttributesCollection();
                    that._updateConnections(leftAttributesCollection, dataMetrics);
                    that._updateConnections(rightAttributesCollection, dataMetrics);
                });
            },
            _updateMetricsConnectorsConnections: function(dataSourceCountModel){
                var metricName, metric = null;

                var rowsCollection = this.getConnectorsRowsCollection();
                var dataMetrics = dataSourceCountModel.get("dataMetrics");
                _.each(rowsCollection.models, function(row){
                    if (row.isMetricTypeConnection()){
                        metricName = row.getMetricName();
                        metric = _.filter(dataMetrics, function(obj){
                            return obj.metricType === metricName;
                        });
                    }
                    if (_.isArray(metric)){
                        //daniel simulate connection change
                        //row.setConnections(5);
                        row.setConnections(metric.length === 0 ? CONST.NO_CONNECTION_VALUE : metric[0].counter);
                    }

                }, this);
            },
            _updateConnections: function(attributesCollection, dataMetrics){
                var metricName, metric = "";
                _.each(attributesCollection.models, function(model){
                    metricName = model.getMetricName();
                    metric = _.filter(dataMetrics, function(obj){
                        return obj.metricType === metricName;
                    });
                    //daniel simulate connection change
                    //model.setConnections(5);
                    model.setConnections(metric.length === 0 ? CONST.NO_CONNECTION_VALUE : metric[0].counter);
                });
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return IntegrationsCategoriesCollection;
});
